import React from 'react';
import FulltextInput from './FulltextInput';

const Fulltext = ({register, selected}) => (
    <div className="form-group">
        <FulltextInput register={register} selected={selected} />
    </div>
);

export default Fulltext;
